/**
 * @module webdnn
 */
/** Don't Remove This comment block */
import WeightDecoderEightbit from "./weight_decoder_eightbit";
import WeightDecoderRaw from "./weight_decoder_raw";
/**
 * @protected
 */
export default function getWeightDecoder(name) {
    switch (name) {
        case 'raw':
            return new WeightDecoderRaw();
        case 'eightbit':
            return new WeightDecoderEightbit();
        default:
            throw new Error('Unknown weight encoding');
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/descriptor_runner/decoder/get_weight_decoder.js
// module id = 3
// module chunks = 0